import Sidebar from '@components/sidebar';
import { ListUsersByEpisodes } from '../../../../graphql/Query/roads';
import { useQuery } from '@apollo/client';
import { FaRegArrowAltCircleRight, FaRegArrowAltCircleDown } from 'react-icons/fa';
import { useState } from 'react';
import Avatar from '@components/avatar';

const Inten = ({ iten }) => {
  const [open, setOpenModal] = useState(false);

  const getUser = () => {
    return iten.users.map((e) => {
      return (
        <div className="row mb-1">
        <div className="col-2">
          <Avatar
            initials
            color={'light-primary'}
            content={e.fullName || ''}
          /></div>
          <div className="col p-0">{e.fullName}</div>
        </div>
      );
    });
  };

  return (
    <>
      <div className="row">
        <div
          className={`btn_no_active_chalent ${open && 'active'}`}
          onClick={() => setOpenModal(!open)}
        >
          <div className="title_data">{iten.title}</div>
          <div className="nun_data"> Se han unido: {iten.users.length} </div>
          {
            open ? (
                <FaRegArrowAltCircleDown
                className="icon"
                width={40}
                color="#ffffff"
              />) : (
                <FaRegArrowAltCircleRight
                className="icon"
                width={40}
                color="#B9B9C3"
              />)
          }

        </div>
        {open && getUser()}
      </div>
    </>
  );
};

const ModalChallenge = ({ open, toggleSidebar, roadId }) => {
  const { data, loading } = useQuery(ListUsersByEpisodes, {
    variables: { roadId }
  });

  const array = data?.listUsersByEpisodes;

  const getUser = () => {
    let nun = 0;
    for (let index = 0; index < array.length; index++) {
      const element = array[index];
      console.log(element.users.length);
      nun = nun + element.users.length;
    }
    return nun;
  };

  return (
    <Sidebar
      size="lg"
      open={open}
      title={''}
      headerClassName="mb-1"
      contentClassName="pt-0"
      toggleSidebar={toggleSidebar}
      onClosed={toggleSidebar}
    >
      <div className="modal_title_data">
        Unidos al Challenge: {!loading ? getUser() : 0}
      </div>
      {!loading ? array.map((e) => <Inten iten={e} key={e} />) : <></>}
    </Sidebar>
  );
};

export default ModalChallenge;
